import { render, staticRenderFns } from "./expireTeamDialog.vue?vue&type=template&id=6dccdc4f&scoped=true&"
import script from "./expireTeamDialog.vue?vue&type=script&lang=js&"
export * from "./expireTeamDialog.vue?vue&type=script&lang=js&"
import style0 from "./expireTeamDialog.vue?vue&type=style&index=0&id=6dccdc4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dccdc4f",
  null
  
)

export default component.exports